import Text from 'components/Text/Text';
import React from 'react';
import Button from 'components/Button/Button';
import style from './ControlButton.module.scss';

interface IControlButton {
	label: string;
	onClick: () => void;
	isShowControl: boolean;
}

const ControlButton: React.FC<IControlButton> = ({ label, onClick, isShowControl }) => {
	return (
		<>
			{isShowControl && (
				<Button className={style.btn} onClick={onClick}>
					<Text translationNameSpace="form" translationKey={label} asFragment={true} />
				</Button>
			)}
		</>
	);
};

export default ControlButton;
